import { connect } from "react-redux";
import { ImageSelectionQuestion as Component } from "../ImageSelectionQuestion";
import { isqSelectOption, isqSubmit, isqReset } from "./store/actions";

function mapDispatchToProps(dispatch) {
  return {
    selectOption: (params) => {
      dispatch(isqSelectOption(params));
    },
    submitAnswer: (id, correctness) => {
      dispatch(isqSubmit({ id: id, correctness: correctness }));
    },
    resetAnswer: (id) => {
      try {
        dispatch(isqReset(id));
      } catch (error) {
        console.error("Error in resetAnswer:", error);
      }
    },
  };
}

function mapStateToProps(state, ownProps) {
  const { isq } = state;

  let totalAttempts = ownProps.totalAttempts;
  if (isq[ownProps.id]?.attempts) {
    totalAttempts = ownProps.totalAttempts - isq[ownProps.id].attempts;
  }

  let options = ownProps.options;
  const disabledOptions = Array.isArray(isq[ownProps.id]?.disabled)
    ? isq[ownProps.id].disabled.map((item) => Object.values(item)[0])
    : [];

  const disabledHotspots = Array.isArray(isq[ownProps.id]?.disabled)
    ? isq[ownProps.id].disabled.map((item) => Object.keys(item)[0])
    : [];

  options = options.map((option) => ({
    ...option,
    disabled: disabledOptions.includes(option.id),
  }));

  let grid = { ...ownProps.grid };

  const enabledHotspots = grid.data.hotspotOrder
    .filter((hotspot) => !disabledHotspots.includes(String(hotspot)))
    .sort();

  const selectedHotspot =
    enabledHotspots.length > 0 ? enabledHotspots[0] : null;

  const updatedHotspots = JSON.parse(JSON.stringify(grid.data.hotspots));

  if (isq[ownProps.id]?.correctness) {
    isq[ownProps.id]?.correctness.forEach((item) => {
      const [hotspotId, isCorrect] = Object.entries(item)[0];
      updatedHotspots[hotspotId] = {
        ...updatedHotspots[hotspotId],
        isCorrect: isCorrect,
      };
    });
  }

  if (
    Array.isArray(isq[ownProps.id]?.disabled) &&
    isq[ownProps.id].disabled.length > 0
  ) {
    isq[ownProps.id].disabled.forEach((item) => {
      const [hotspotId, optionId] = Object.entries(item)[0];
      const option = options.find((opt) => opt.id === optionId);
      const img = option?.image?.src || null;

      updatedHotspots[hotspotId] = {
        ...updatedHotspots[hotspotId],
        props: {
          ...(updatedHotspots[hotspotId]?.props || {}),
          image: img,
        },
      };
    });
  } else {
    Object.keys(updatedHotspots).forEach((hotspotId) => {
      if (
        updatedHotspots[hotspotId]?.props &&
        "image" in updatedHotspots[hotspotId].props
      ) {
        const { image, ...restProps } = updatedHotspots[hotspotId].props;
        updatedHotspots[hotspotId] = {
          ...updatedHotspots[hotspotId],
          props: restProps,
        };
      }
    });
  }

  grid = {
    ...grid,
    data: {
      ...grid.data,
      hotspots: updatedHotspots,
    },
  };

  return {
    ...ownProps,
    selectedHotspot: selectedHotspot,
    options: options,
    totalAttempts: totalAttempts,
    attempted: isq[ownProps.id]?.attempted,
    selectedOptions: isq[ownProps.id]?.disabled || [],
    grid: grid,
  };
}

export const ImageSelectionQuestionRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
